import React, { Component } from "react";
import { withTranslation } from "react-i18next";

import { Cancel, CallForHelp, PhonePad } from "../../../components";
import MainLayout from "../../../layout";

import CheckInfo from "./CheckInfo";
import CheckInfoHelp from "./CheckInfoHelp";

const SUBSCREENS = {
  MAIN: 1,
  HELP: 2,
  CANCEL: 3,
  ADD_PHONE_NUMBER: 4,
  CALL_FOR_HELP: 5,
};

const STEP = 2;

class CheckInfoScreen extends Component {
  state = {
    screen: SUBSCREENS.MAIN,
    extraPhone: "",
  };

  renderLayout = props => {
    const { t } = this.props;

    const step = (t("kl_step").message || "Step") + " " + STEP;
    const title = t("kl_check_validate").message || "Check and Validate Contact Information";

    return <MainLayout step={step} title={title} {...props} />;
  };

  goBack = () => this.setState({ screen: SUBSCREENS.MAIN });
  goToHelp = () => this.setState({ screen: SUBSCREENS.HELP });
  goToCancel = () => this.setState({ screen: SUBSCREENS.CANCEL });
  goToAddPhoneNumber = () => this.setState({ screen: SUBSCREENS.ADD_PHONE_NUMBER });
  goToCallForHelp = () => this.setState({ screen: SUBSCREENS.CALL_FOR_HELP });
  saveExtraPhone = extraPhone => this.setState({ screen: SUBSCREENS.MAIN, extraPhone });

  render() {
    const { communication, onGoToNextScreenWithState, onAbort, t } = this.props;
    const { screen, extraPhone } = this.state;

    switch (screen) {
      default:
      case SUBSCREENS.MAIN:
        return (
          <CheckInfo
            renderLayout={this.renderLayout}
            extraPhone={extraPhone}
            communication={communication}
            onGoToHelpScreen={this.goToHelp}
            onGoToCancelScreen={this.goToCancel}
            onGoToAddPhoneNumber={this.goToAddPhoneNumber}
            onGoToNextScreenWithState={onGoToNextScreenWithState}
          />
        );

      case SUBSCREENS.HELP:
        return <CheckInfoHelp renderLayout={this.renderLayout} onGoBack={this.goBack} onGoToCallForHelp={this.goToCallForHelp} />;

      case SUBSCREENS.CANCEL:
        return <Cancel onGoBack={this.goBack} onAbort={onAbort} />;

      case SUBSCREENS.ADD_PHONE_NUMBER:
        return (
          <PhonePad
            renderLayout={this.renderLayout}
            leftButtonCancel={true}
            rightButtonText={t("kl_next").message || "Next"}
            phone={extraPhone}
            onGoToHelpScreen={this.goToHelp}
            onGoToCancelScreen={this.goToCancel}
            onBackCancel={this.goBack}
            onConfirm={this.saveExtraPhone}
          />
        );

      case SUBSCREENS.CALL_FOR_HELP:
        return <CallForHelp onGoBack={this.goToHelp} communication={communication} />;
    }
  }
}

export default withTranslation()(CheckInfoScreen);
